export default {
  methods: {
    testMapLink(url: string): boolean {
      const regex = /^https:\/\/www\.google\.com\/maps\/embed/;
      return regex.test(url);
    },
  },
};
